import { render, staticRenderFns } from "./ForcaDeVendasExibir.vue?vue&type=template&id=39105659"
import script from "./ForcaDeVendasExibir.vue?vue&type=script&lang=js"
export * from "./ForcaDeVendasExibir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports